/**
 * Utility functions for URL handling and proxy configuration
 */

/**
 * Gets a clean origin URL without double protocols
 * Handles edge cases where window.location.origin might have malformed protocols
 * @returns Clean origin URL (e.g., "https://dev.openparachute.dev")
 */
export function getCleanOrigin(): string {
  const origin = window.location.origin;
  // Remove any double protocol issues (https://https:// -> https://)
  return origin.replace(/^https?:\/\/https?:\/\//, 'https://');
}

/**
 * Builds a proxy URL for analytics services
 * @param service - The service name (e.g., 'mixpanel', 'segment', 'sentry', 'intercom')
 * @returns Full proxy URL (e.g., "https://dev.openparachute.dev/mixpanel-proxy")
 */
export function buildProxyUrl(service: string): string {
  const cleanOrigin = getCleanOrigin();
  return `${cleanOrigin}/${service}-proxy`;
}

/**
 * Checks if the current environment is local development
 * @returns true if running on localhost or 127.0.0.1 only
 */
export function isLocalhost(): boolean {
  const hostname = window.location.hostname;
  return hostname === 'localhost' || 
         hostname === '127.0.0.1' ||
         hostname.includes('localhost') ||
         hostname.startsWith('127.') ||
         hostname.startsWith('192.168.') ||
         hostname.startsWith('10.') ||
         hostname === '0.0.0.0';
}

/**
 * Checks if the current environment should use direct analytics (no proxy)
 * @returns true for localhost only, false for all remote environments (dev, stage, production)
 */
export function shouldUseDirectAnalytics(): boolean {
  return isLocalhost();
}